import React from 'react';
import * as Icons from '@blueprintjs/icons';
import { ReactSVG } from "react-svg";
import { Icon } from '@blueprintjs/core';
import {
    getTheme,
    THEME_CHANGED_COMMAND,
    applySvgIconTheme,
} from '../modules/layoutv2/theme';

const ActivityBarIcon2 = (props) => {
    const { icon } = props;
    const [theme, setTheme] = React.useState(getTheme);

    React.useEffect(() => {
        setTheme(getTheme());
        const ctx = window['bodapro-context'];
        if (!ctx?.subscribeToCommand) return undefined;
        const sub = ctx.subscribeToCommand(THEME_CHANGED_COMMAND, ({ theme: next }) => {
            if (next === 'light' || next === 'dark') {
                setTheme(next);
            }
        });
        return () => sub?.unsubscribe?.();
    }, []);

    const camelize = (str) => {
        let _str = str.replace(/-(.)/g, (m, chr) => chr.toUpperCase().replace(/-/g, ''));
        return _str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
          return word.toUpperCase();
        }).replace(/\s+/g, '');
    }
    
    //check svg 
    if(icon.endsWith('.svg')){
        const size = props.size || 24;
        return (<ReactSVG 
                    key={theme}
                    onClick={() => typeof props.onClick === "function" && props.onClick()}
                    loading={() => <span>Loading</span>}
                    src={icon} 
                    afterInjection={(svg) => {
                        // console.log(svg)
                      }}
                    beforeInjection={(svg) => {
                        applySvgIconTheme(svg, { size, theme });
                    }}
                />);
    }

    const camelizedIcon = camelize(icon);
    if(Icons[camelizedIcon] !== undefined){
        return ( <Icon icon={icon} size={24} intent="secondary" onClick={() => props.onClick()}/>);
    }

    return (<Icon icon="help" size={24} intent="secondary" onClick={() => props.onClick()}/>);


}

export default ActivityBarIcon2;
